import { Drilling } from "./Drilling";
import { Threads } from "./Threads";
import { CountersinkHoles } from "./CountersinkHoles";
import { CounterboreHoles } from "./CounterboreHoles";
import { Grinding } from "./Grinding";
import cs from "./AdditionalProcessing.module.scss";

export const AdditionalMetalProcessing = ({
  services,
  element,
  readOnly,
  onChange,
}) => {
  const params = element.parameters;

  return (
    <div className="AdditionalProcessing">
      <div className="h4 mb24">Dodatkowa obróbka metali</div>

      <div className={cs.services}>
        {services.map((service) => {
          switch (service._id) {
            case 123:
              return (
                <Grinding
                  params={params}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            case 125:
              if (
                readOnly &&
                (!params.holes?.drilledHoles ||
                  params.holes?.drilledHoles.length === 0)
              ) {
                return null;
              }

              return (
                <Drilling
                  holes={params.holes?.drilledHoles}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            case 126:
              return (
                <Threads
                  holes={params.holes?.threadHoles}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            case 127:
              return (
                <CountersinkHoles
                  holes={params.holes?.counter_sink_holes}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            case 128:
              return (
                <CounterboreHoles
                  holes={params.holes?.counter_bore_holes}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};
